import { dictionary } from '../../engine/dictionary';
import type { PuzzleMode } from '../../engine/types';
import { BouquetBoard } from './Board';
import {
  BOUQUET_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type BouquetConfig,
  type BouquetMove,
  type BouquetState,
} from './logic';

export const bouquetMode: PuzzleMode<BouquetState, BouquetMove, BouquetConfig> = {
  id: 'bouquet',
  name: 'Bouquet',
  tagline: 'Four words, one set of guesses',
  description:
    'Crack four hidden words at once. Every guess is scored against all four boards — solve them all before your guesses run out.',
  accent: 'vine',
  glyph: 'quad',
  howToPlay: [
    { title: 'One guess, four boards', body: 'Each word you guess is scored against all four hidden words at once.' },
    { title: 'Read all four', body: 'Green = right spot, amber = wrong spot, grey = absent — per board.' },
    { title: 'Clear the bouquet', body: 'Solve all four words before your shared guesses run out.' },
  ],
  difficulties: BOUQUET_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove: (state, move) => {
    const base = validateMove(state, move);
    if (!base.ok) return base;
    if (move.type === 'submit' && !dictionary.isValid(state.current)) {
      return { ok: false, reason: 'Not in word list' };
    }
    return { ok: true };
  },
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: BouquetBoard,
};
